import { useState } from 'react'
import { useFormsStore } from '../../../../stores/onboarding'
import { usePersonalStore } from '../../../../stores/personalInfo'
import { useInitializeStore } from '../../../../stores/initialize'
import Toast from 'react-native-toast-message'
import { globalStyles } from '../../../../static/styles/global'
import { ActivityIndicator, ScrollView, View } from 'react-native'
import HomeDetailsHeader from '../../../home/HomeDetailsHeader'
import Card from '../../../shared/card/Card'
import CustomButton from '../../../shared/button/Button'
import Canvas from '../../../canvas'
import moment from 'moment'
import { Text } from 'react-native'

const HandBook = ({ navigation, route }) => {

    const { essUserOnBoardingKey, essUserOnBoardingFormKey, essFormKey } = route.params
    const { loading, postredmondhandbook, downloadFile } = useFormsStore()
    const [hasDrawn, setHasDrawn] = useState()
    const [signatureDataURL, setSignatureDataURL] = useState('')
    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const data = {
        completeOnline: true,
        essUserKey: intializestore.initializeData.userkey,
        entityId: personalstore.personalData?.entityId,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        essObKey: essUserOnBoardingKey,
        sign: signatureDataURL
    }

    const handlesubmit = async () => {
        const response = await postredmondhandbook(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }


    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title="Redmonds Handbook"
                    />

                </View>
                <Text style={{ textAlign: "center", fontWeight: 'bold', textDecorationLine: 'underline', color: 'lightblue' }} onPress={() => { downloadFile(essFormKey) }}>View Instructions Here</Text>


            </View>

            <ScrollView>

                <Card
                    style={{
                        fontFamily: 'Arial, sans-serif',
                        lineHeight: '1.6',
                        fontSize: '11px'
                    }}
                >
                    <h2>Employee Handbook Acknowledgment and Receipt</h2>

                    <p>
                        I hereby acknowledge receipt of the employee Handbook of ROC. I
                        understand and agree that it is my responsibility to read and comply
                        with the policies in the Handbook.
                    </p>

                    <p>
                        I understand that the Handbook and all other written and oral
                        materials provided to me are intended for informational purposes
                        only. The Handbook, Company practices, and other communications do
                        not create an employment contract or term. I understand that the
                        policies and benefits, both in the Handbook and those communicated
                        to me in any other fashion, are subject to interpretation, review,
                        removal, and change by management at any time without notice.
                    </p>

                    <p>
                        I further understand that I am an at-will employee and that neither
                        this document nor any other communication shall bind the Company to
                        employ me now or hereafter and that my employment may be terminated
                        by me or the Company without reason at any time. I understand that
                        no representative of the Company has any authority to enter into any
                        agreement for employment for any specified period of time or to
                        assure any other personnel action or to assure any benefits or terms
                        or conditions of employment or make anyagreement contrary to the
                        foregoing
                    </p>

                    <p>
                        I also understand and agree that this Handbook may not be modified
                        orally and that only the President of the Companymay make a
                        commitment for employment. I also understand that if such an
                        agreement is made, it must be in writing and signed by the president
                        of the Company.
                    </p>
                    <div style={{ marginTop: '60px' }}>
                        <div
                            style={{ fontWeight: 'bold', fontSize: '11px' }}
                            id="employeeName"
                        >
                            {personalstore?.personalData?.firstName}{' '}
                            {personalstore?.personalData?.middleInitial}{' '}
                            {personalstore?.personalData?.lastName}
                        </div>
                        <div
                            style={{
                                width: '180px',
                                borderBottom: '1px solid #000',
                                marginBottom: '5px'
                            }}
                        ></div>
                        <div style={{ fontSize: '14px', color: '#000' }}>
                            Employee’s Name in Print
                        </div>
                    </div>
                    <div style={{ marginTop: '60px' }}>
                        <div
                            style={{ fontWeight: 'bold', fontSize: '11px' }}
                            id="employeeName"
                        >
                            <Canvas
                                setSignatureDataURL={setSignatureDataURL}
                                setHasDrawn={setHasDrawn}
                                hasDrawn={hasDrawn}
                            />
                        </div>
                        <div style={{ fontSize: '14px', color: '#000' }}>
                            Signature of Employee
                        </div>
                    </div>
                    <div style={{ marginTop: '60px' }}>
                        <div
                            style={{ fontWeight: 'bold', fontSize: '11px' }}
                            id="employeeName"
                        >
                            {moment().format('MM/DD/YYYY')}
                        </div>
                        <div
                            style={{
                                width: '180px',
                                borderBottom: '1px solid #000',
                                marginBottom: '5px'
                            }}
                        ></div>
                        <div style={{ fontSize: '14px', color: '#000' }}>
                            Date Signed by Employee
                        </div>
                    </div>
                    <p>
                        <b>TO BE PLACED IN EMPLOYEE’S PERSONNEL FILE</b>
                    </p>
                </Card>
                {loading ? (
                    <ActivityIndicator />
                ) : (
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() => navigation.navigate('OnboardingForms')}
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>
                )}

            </ScrollView>
        </>
    )
}

export default HandBook
